module.exports = __webpack_public_path__ + "img/10_106.349076ae.png";